import { useEffect, useState } from 'react'
import SliderImages from '../../component/CustomSlider/SliderImages'
import './style.css'
import DateRangeSelector from '../Flights/Dropdown/DateSelector'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import {
  setLoadingFalse,
  setLoadingTrue
} from '../../Config/Actions/loadingActions'
import axios from 'axios'
import { Country } from 'country-state-city'
import SearchDropdown from '../Flights/Dropdown/SearchDropdown'

const Visa = () => {
  const [sliderImages, setSliderImages] = useState([])
  const [flightsForm, setFlightsForm] = useState([])
  const [selectedFare, setSelectedFare] = useState('Single Entry')
  const [tripType, setTripType] = useState('Visitor / Tourist')
  const [dateRangeOpen, setDateRangeOpen] = useState(false)
  const [success, setSuccess] = useState(false)

  useEffect(() => {
    fetch('/PackageJson/Visa/VisaImages.json')
      .then(response => response.json())
      .then(data => {
        setSliderImages(data)
      })
      .catch(error => console.error('Error loading JSON:', error))
  }, [])
  useEffect(() => {
    fetch('/PackageJson/Visa/VisaForm.json')
      .then(response => response.json())
      .then(data => {
        setFlightsForm(data)
      })
      .catch(error => console.error('Error loading JSON:', error))
  }, [])

  const [formData, setFormData] = useState({
    full_name: '',
    contact: '',
    email: '',
    product_type: 'hotels',
    departureDate: '',
    country: ''
  })
  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }))
  }
  const handleChangeTripType = event => {
    setTripType(event.target.value)
  }
  const dispatch = useDispatch()
  const handleSubmit = async e => {
    e.preventDefault()
    dispatch(setLoadingTrue())
    const FormData = {
      to: formData.email,
      subject: 'Visa',
      fullName: formData.full_name,
      Email: formData.email,
      Contact: formData.contact,
      startDate: moment(formData.departureDate).format('DD MMM YYYY'),
      VisaValid: selectedFare,
      VisaType: tripType,
      country: formData.country
    }

    try {
      const response = await axios.post(
        'https://arrshiyanatravels.com/api/send_email.php',
        FormData
      )
      dispatch(setLoadingFalse())
      setSuccess(true)
      setTimeout(() => setSuccess(false), 3000)
      setFormData(prevState => ({
        ...prevState,
        full_name: '',
        contact: '',
        email: '',
        product_type: 'hotels',
        departureDate: '',
        country: ''
      }))
    } catch (error) {
      console.error('Error submitting form:', error)
    }
  }

  const handleCountrySelect = selectedCountry => {
    setFormData(prevState => ({
      ...prevState,
      country: selectedCountry
    }))
  }
  const handleOnchangeDate = item => {
    setFormData(prevState => ({
      ...prevState,
      departureDate: item.selection.startDate
    }))
  }
  return (
    <div>
      <div className='hotels Holidays'>
        <div
          style={{
            height: '',
            backgroundImage: `url(${flightsForm[0]?.displayBackground})`,
            backgroundPosition: 'center',
            backgroundSize: 'Cover',
            backgroundRepeat: 'no-repeat',
            padding: '80px 0px'
          }}
          className='product-container'
        >
          <div className='container'>
            <div className='product-area'>
              <p>Get Your Visas Right on Time with Us</p>
              <form onSubmit={handleSubmit}>
                <div className='q-label'>
                  <p>Visa Type:</p>
                </div>
                <div className='radio-group'>
                  <label
                    className={`radio-label ${
                      tripType === 'Visitor / Tourist' ? 'selected' : ''
                    }`}
                  >
                    <input
                      type='radio'
                      name='tripType'
                      value='Visitor / Tourist'
                      checked={tripType === 'Visitor / Tourist'}
                      onChange={handleChangeTripType}
                      className='radio-input'
                    />
                    <span className='custom-radio'></span>
                    Visitor / Tourist
                  </label>

                  <label
                    className={`radio-label ${
                      tripType === 'Business' ? 'selected' : ''
                    }`}
                  >
                    <input
                      type='radio'
                      name='tripType'
                      value='Business'
                      checked={tripType === 'Business'}
                      onChange={handleChangeTripType}
                      className='radio-input'
                    />
                    <span className='custom-radio'></span>
                    Business
                  </label>
                  <label
                    className={`radio-label ${
                      tripType === 'Student' ? 'selected' : ''
                    }`}
                  >
                    <input
                      type='radio'
                      name='tripType'
                      value='Student'
                      checked={tripType === 'Student'}
                      onChange={handleChangeTripType}
                      className='radio-input'
                    />
                    <span className='custom-radio'></span>
                    Student
                  </label>
                </div>
                <div className='row'>
                  <div
                    className='col-xl-6 col-lg-5 col-md-12 col-sm-12'
                    style={{ width: '100%' }}
                  >
                    <div className='search-input-box flight-from'>
                      <label className='form-label'>Country</label>
                      {/* <input
                        className='autocomplete-airport inp-text '
                        id='search-user'
                        type='text'
                        name='country'
                        value={formData.country}
                        onChange={handleChange}
                        autoComplete='off'
                        required
                      /> */}
                      <SearchDropdown
                        data={Country.getAllCountries()} // Fetches country list
                        placeholder=''
                        value={formData.country}
                        formData={formData}
                        onSelect={handleCountrySelect}
                      />
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div
                    className='col-lg-8 col-md-12 col-12 enquiry-form'
                    style={{ width: '100%' }}
                  >
                    <div className='row'>
                      <div className='col-md-3  m-b-10'>
                        <div className='form-group'>
                          <input
                            type='text'
                            className='form-control'
                            name='full_name'
                            placeholder='Full Name'
                            value={formData.full_name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className='col-md-3  m-b-10'>
                        <div className='form-group'>
                          <input
                            type='text'
                            className='form-control'
                            name='contact'
                            placeholder='Mobile Number'
                            pattern='^\d*$'
                            value={formData.contact}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className='col-md-3 '>
                        <div className='form-group'>
                          <input
                            type='text'
                            className='form-control'
                            name='date'
                            onClick={() => setDateRangeOpen(true)}
                            placeholder='Travel Date'
                            value={
                              formData.departureDate
                                ? moment(formData.departureDate).format(
                                    'DD MMM YYYY'
                                  )
                                : formData.departureDate
                            }
                            required
                          />
                          <input
                            type='hidden'
                            name='product_type'
                            value='hotels'
                          />
                          <DateRangeSelector
                            dateRangeOpen={dateRangeOpen}
                            setDateRangeOpen={setDateRangeOpen}
                            handleOnchangeDate={handleOnchangeDate}
                          />
                        </div>
                      </div>
                      <div className='col-md-3'>
                        <div className='form-group'>
                          <input
                            type='text'
                            className='form-control'
                            name='email'
                            placeholder='Email ID'
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                          <input
                            type='hidden'
                            name='product_type'
                            value='hotels'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-6 col-md-12 col-12'>
                      <div className='quota-box'>
                        <div className='q-label'>
                          <p>Visa Valid:</p>
                        </div>
                        <div className='radio-group'>
                          <label
                            className={`radio-label ${
                              selectedFare === 'Single Entry' ? 'selected' : ''
                            }`}
                          >
                            <input
                              type='radio'
                              name='Regular'
                              value='Single Entry'
                              checked={selectedFare === 'Single Entry'}
                              onChange={e => setSelectedFare(e.target.value)}
                              className='radio-input'
                            />
                            <span className='custom-radio'></span>Single Entry
                          </label>

                          <label
                            className={`radio-label ${
                              selectedFare === 'Multiple Entry'
                                ? 'selected'
                                : ''
                            }`}
                          >
                            <input
                              type='radio'
                              name='Student'
                              value='Multiple Entry'
                              checked={selectedFare === 'Multiple Entry'}
                              onChange={e => setSelectedFare(e.target.value)}
                              className='radio-input'
                            />
                            <span className='custom-radio'></span>Multiple Entry
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className='col-lg-6 col-md-12 col-12'>
                      <div className='recent-box'>
                        <div id='date'></div>
                      </div>
                    </div>
                  </div>
               
                </div>
                <div className='button-center'>
                  <button type='submit' className='btn search-btn'>
                    <span className='button-text'>ENQUIRE NOW</span>
                  </button>
                </div>
              </form>
              {success && (
                <div className='success-popup'>Thank you for your enquiry!</div>
              )}
            </div>
          </div>
        </div>
        {/* <h2 className='text-white'>{sliderImages[0]?.title}</h2> */}
        <SliderImages data={sliderImages[0]?.displayImages || []} />
      </div>
    </div>
  )
}
export default Visa
